module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Blagomira Halacheva – Boggie – was born in Bulgaria. She graduated from medical college in Plovdiv and now she practices in Austria. Her son Rosen lives with his family in Wales, UK. The novel "), _c('em', [_vm._v("8 Seconds")]), _vm._v(" was ranked second in the competition for a Bulgarian novel of the Bukvite Foundation.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("A film script was written based on the novel. The Silent World Publishing House published the first book titled "), _c('em', [_vm._v("Children of Sin")]), _vm._v(", the second book "), _c('em', [_vm._v("Traps for Love and Power")]), _vm._v(", and the third book of the trilogy, "), _c('em', [_vm._v("Redemption,")]), _vm._v(" of the Maria-Magdalene Trilogy.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("In 2014 at the Screen-Craft Family-Friendly Script Contest, the script "), _c('em', [_vm._v("Double Dimension")]), _vm._v(" by Blagomira Halacheva qualified of the Quarter-Finalists.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bbe9e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0